import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Badge,
  Grid,
  Button,
  Icon,
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { FaHandsHelping, FaFileSignature, FaIdCard } from 'react-icons/fa';

const CinquePerMille = () => {
  return (
    <Box bg="#1a1d23" color="white" minH="100vh" py={{ base: 12, md: 16 }}>
      <Container maxW="5xl">
        <VStack spacing={8} align="stretch">
          <VStack spacing={4} textAlign="center">
            <Badge
              bg="#ffcc00"
              color="black"
              px={4}
              py={2}
              borderRadius="6px"
              fontSize="sm"
              fontWeight="600"
            >
              5x1000
            </Badge>
            <Heading as="h1" size="2xl" fontWeight="800">
              Dona il tuo 5x1000 a CIL
            </Heading>
            <Text
              color="gray.300"
              fontSize={{ base: 'md', md: 'lg' }}
              maxW="3xl"
            >
              Con il 5x1000 puoi sostenere le attivita educative, culturali e
              sociali di CIL senza alcun costo aggiuntivo. E un gesto semplice
              che ci aiuta a far crescere progetti per bambini, ragazzi,
              famiglie e comunita.
            </Text>
          </VStack>

          <Box
            bg="#25282d"
            border="1px solid"
            borderColor="rgba(255, 204, 0, 0.35)"
            borderRadius="10px"
            p={{ base: 6, md: 8 }}
          >
            <VStack spacing={3} textAlign="center">
              <Text color="gray.300" fontSize="md">
                Codice fiscale CIL da inserire nella dichiarazione:
              </Text>
              <Heading as="h2" size="xl" color="#ffcc00" letterSpacing="0.08em">
                94090260012
              </Heading>
            </VStack>
          </Box>

          <Grid templateColumns={{ base: '1fr', md: 'repeat(3, 1fr)' }} gap={6}>
            <Box
              bg="#25282d"
              borderRadius="8px"
              p={6}
              border="1px solid"
              borderColor="rgba(255, 255, 255, 0.12)"
            >
              <VStack align="start" spacing={3}>
                <Icon as={FaFileSignature} color="#ffcc00" boxSize={6} />
                <Heading as="h3" size="md">
                  1. Trova il riquadro corretto
                </Heading>
                <Text color="gray.300">
                  Cerca nella dichiarazione il riquadro dedicato alla scelta del
                  5x1000.
                </Text>
              </VStack>
            </Box>

            <Box
              bg="#25282d"
              borderRadius="8px"
              p={6}
              border="1px solid"
              borderColor="rgba(255, 255, 255, 0.12)"
            >
              <VStack align="start" spacing={3}>
                <Icon as={FaHandsHelping} color="#ffcc00" boxSize={6} />
                <Heading as="h3" size="md">
                  2. Metti la tua firma
                </Heading>
                <Text color="gray.300">
                  Firma nello spazio dedicato al sostegno degli enti del Terzo
                  Settore e del volontariato.
                </Text>
              </VStack>
            </Box>

            <Box
              bg="#25282d"
              borderRadius="8px"
              p={6}
              border="1px solid"
              borderColor="rgba(255, 255, 255, 0.12)"
            >
              <VStack align="start" spacing={3}>
                <Icon as={FaIdCard} color="#ffcc00" boxSize={6} />
                <Heading as="h3" size="md">
                  3. Inserisci il codice fiscale
                </Heading>
                <Text color="gray.300">
                  Riporta il codice fiscale di CIL: <strong>94090260012</strong>
                  .
                </Text>
              </VStack>
            </Box>
          </Grid>

          <Box
            bg="#25282d"
            borderRadius="8px"
            p={{ base: 6, md: 8 }}
            border="1px solid"
            borderColor="rgba(255, 255, 255, 0.12)"
          >
            <VStack spacing={4} align="start">
              <Heading as="h2" size="md">
                Perche e importante
              </Heading>
              <Text color="gray.300">
                Il 5x1000 non sostituisce l&apos;8x1000 e non comporta spese
                aggiuntive: se non lo scegli, quella quota resta allo Stato.
                Scegliendo CIL, contribuisci in modo concreto alle nostre
                attivita e ai progetti sul territorio.
              </Text>
            </VStack>
          </Box>

          <VStack spacing={4} pt={2}>
            <Button
              as={Link}
              to="/contattaci"
              bg="#ffcc00"
              color="black"
              size="lg"
              fontWeight="700"
              _hover={{ bg: '#e6b800' }}
            >
              Hai dubbi? Contattaci
            </Button>
            <Text color="gray.400" fontSize="sm" textAlign="center">
              Grazie per il tuo supporto: insieme facciamo crescere CIL.
            </Text>
          </VStack>
        </VStack>
      </Container>
    </Box>
  );
};

export default CinquePerMille;
